import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";
import Nifty10Logo from "../../assets/Nifty10-logo-white.png";
import PlayStore from "../../assets/GetItOnGooglePlay_Badge.png";
// import AppStore from "../../assets/GetItOnApp_Store_Badge.svg";
import { useLocation } from "react-router-dom";
// import Background from "../../assets/Nifty10_background.jpeg";
import Background from "../../assets/header_nifty.jpeg";
import AlertBell from "../../assets/alert.png"
const Header = () => {
  const location = useLocation();
  const mobileHideRoutes = ['/about-us', '/terms-conditions', '/refund-policy', '/points-system', '/privacy-policy', '/play-guide','/help-desk'];
  const shouldHideOnMobile = mobileHideRoutes.includes(location.pathname);
const hideBannerRoutes = [
    "/about-us",
    "/terms-conditions",
    "/refund-policy",
    "/points-system",
    "/privacy-policy",
    "/help-desk",
    "/play-guide"
  ];

  const showBanner = !hideBannerRoutes.includes(location.pathname);
  // States for mobile input, sending status, and success message
  const [mobile, setMobile] = useState("");
  const [sending, setSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  // Function to send SMS by calling your backend API
  const sendSms = async () => {
    if (!/^\d{10}$/.test(mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setSending(true);
      setSuccessMsg("");
      // Replace this URL with your actual backend endpoint
      const response = await axios.post("https://api.nifty10.in/api/send-sms", {
        mobileNumber: mobile,
      });

      console.log(response.data);

      setSuccessMsg("App link sent successfully!");

      setTimeout(() => {
        setSuccessMsg(""); // Clear message after 30 seconds
      }, 5000);

      setMobile("");  // reset input on success
    } catch (error) {
      console.error("SMS send failed", error);
      alert("Failed to send SMS. Try again later.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
    


    <header className="header">

      <div className={`home-icon-container animate__animated animate__fadeIn ${shouldHideOnMobile ? "hide-home-mobile" : ""}`}>
        <a href="/home" className="home-icon" aria-label="Go to homepage">
          <FontAwesomeIcon icon={faHouse} />
        </a>
      </div>
      <img
    src={Background}
    className="header_background"
    alt="Nifty10 background"
  />
  {/* <video
  className="header_background"
  autoPlay
  loop
  muted
  playsInline
>
  <source src={Background} type="video/mp4" />
  
</video> */}

  {showBanner && (
        <div className="notification-banner">
          <img
            src={AlertBell}
            alt="alert icon"
            className="notification-icon"
          />
          <span>
            In compliance with the new <span className="highlight">Promotion and Regulation of Online Gaming Act of 2025</span>, cash games and deposits are no longer available on our platform.
          </span>
        </div>
      )}

      <div className="header-container">
        <div className="header-content animate__animated animate__fadeInDown">
          <img
            src={Nifty10Logo}
            alt="Nifty10 Logo"
            className="logo spark-animation"
          />
          <h1 className="header-title">
            Play Fantasy Stocks prediction and win real prizes
          </h1>

          <div className={`input-group ${shouldHideOnMobile ? "hide-home-mobile" : ""}`}>
            <input
              type="tel"
              placeholder="Enter Mobile Number"
              pattern="[0-9]{10}"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              disabled={sending}
            />
            <button
              className="pulse-button"
              onClick={sendSms}
              disabled={sending}
            >
              {sending ? "Sending..." : "Get APP LINK"}
            </button>
          </div>
          {successMsg && <p className="success-message">{successMsg}</p>}

          <div className={`download-buttons animate__animated animate__fadeInUp animate__delay-1s ${shouldHideOnMobile ? "hide-home-mobile" : ""}`}>
            <a
              href="https://play.google.com/store/apps/details?id=com.finpages.nifty"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={PlayStore}
                alt="Get it on Google Play"
              />
            </a>
            <a href="https://apps.apple.com/in/app/nifty10/id6748718480" target="_blank" rel="noopener noreferrer">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/2560px-Download_on_the_App_Store_Badge.svg.png"
                alt="Download on the App Store"
              />
            </a>
          </div>
        </div>
      </div>
    </header></>
  );
};

export default Header;